enum ViewDialogFields {
	PAGE_MODE = "page_mode",
	ZOOM_MODE = "zoom_mode",
	ZOOM = "zoom",
	OPEN_MODE = "open_mode",
	START_PAGE = "start_page",
	FIT_WINDOW = "fit_window",
	CENTER_WINDOW = "center_window",
	TITLE = "title",
	HIDE_TOOLBAR = "hide_toolbar",
	HIDE_MENUBAR = "hide_menubar",
	HIDE_WINDOW_UI = "hide_window_ui",
	TEXT_DIRECTION = "text_direction",
	PRINT_SCALE = "print_scale",
	PRINT_COPIES = "copies",
	PRINT_PAGERANGE = "pagerange",
	PRINT_TRAY = "print_tray",
	PRINT_DUPLEX = "print_duplex",
	VIEW_AREA = "view_area",
	VIEW_CLIP = "view_clip",
	PRINT_AREA = "print_area",
	PRINT_CLIP = "print_clip"
}

export default ViewDialogFields;